import { VRating } from 'vuetify/lib/components/VRating';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VTooltip,
    {
      attrs: { disabled: _vm.disabled, top: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "div",
                _vm._g(
                  {
                    staticClass: "no-wrap",
                    staticStyle: { display: "inline-block" },
                  },
                  on
                ),
                [
                  _c(VRating, {
                    attrs: {
                      readonly: _vm.disabled,
                      size: _vm.tamanho,
                      color: _vm.cor,
                      "background-color": "grey",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.$emit("return", _vm.value.rating)
                      },
                    },
                    model: {
                      value: _vm.value.rating,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "rating", $$v)
                      },
                      expression: "value.rating",
                    },
                  }),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [_c("span", [_vm._v("Clique para avaliar")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }